import { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faXmark, faSearch, faCheck } from "@fortawesome/free-solid-svg-icons";
import CrudApi from "@serie3/common/api/crudApi";
import DocumentsConfig from "@serie3/freelancesplaceapi/Config/Documents/DocumentsConfig";
import DocumentCard from "../../LoggedIn/modules/documents/DocumentCard";

/**
 * linkUrl: full POST URL to link the document, e.g. "/document/finance/42"
 * onLinked: called after a document is successfully linked
 */
const DocumentLinker = ({ show, setShow, linkUrl, onLinked }) => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [linked, setLinked] = useState({});

  useEffect(() => {
    if (!show) { setSearch(""); setLinked({}); return; }
    setLoading(true);
    CrudApi.getAll(DocumentsConfig.endpoints.getAll).then((res) => {
      setDocuments(res.data?.documents || []);
      setLoading(false);
    });
  }, [show]);

  const handleLink = async (doc) => {
    const res = await CrudApi.createNew(`${linkUrl}/attach/${doc.id}`, {}, null, true);
    if (res.status === 200 || res.status === 201) {
      setLinked((prev) => ({ ...prev, [doc.id]: true }));
      if (onLinked) onLinked();
    }
  };

  const filtered = documents.filter((d) =>
    d.name?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>
      <style>{`
        .doc-linker-modal { border-radius: 14px !important; overflow: hidden !important; border: none !important; box-shadow: 0 8px 40px rgba(0,0,0,0.18) !important; }
      `}</style>
      <Modal
        show={show}
        onHide={() => setShow(false)}
        size="xl"
        dialogClassName="modal-90w"
        contentClassName="doc-linker-modal"
      >
        <Modal.Header style={{
          background: "linear-gradient(135deg, #6d28d9, #4c1d95)",
          border: "none", padding: "18px 24px",
          display: "flex", alignItems: "center", justifyContent: "space-between",
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <div style={{
              width: "34px", height: "34px", borderRadius: "8px",
              background: "rgba(255,255,255,0.2)",
              display: "flex", alignItems: "center", justifyContent: "center",
              color: "#fff", fontSize: "1rem",
            }}>
              <FontAwesomeIcon icon={faPlus} />
            </div>
            <span style={{ fontWeight: 700, fontSize: "1.05rem", color: "#fff" }}>
              Add Existing File
            </span>
          </div>
          <button onClick={() => setShow(false)} style={{
            background: "rgba(255,255,255,0.15)", border: "none", borderRadius: "8px",
            width: "32px", height: "32px", display: "flex", alignItems: "center",
            justifyContent: "center", cursor: "pointer", color: "#fff",
          }}>
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </Modal.Header>

        <Modal.Body style={{ background: "#f8f9fb", padding: "20px 24px" }}>
          {/* Search */}
          <div style={{
            display: "flex", alignItems: "center", gap: "10px",
            background: "#fff", border: "1px solid #e0e0e0", borderRadius: "10px",
            padding: "8px 14px", marginBottom: "20px",
          }}>
            <FontAwesomeIcon icon={faSearch} style={{ color: "#9e9e9e", fontSize: "0.85rem" }} />
            <input
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search files…"
              style={{ border: "none", outline: "none", flex: 1, fontSize: "0.9rem", color: "#212121", background: "transparent" }}
            />
          </div>

          {loading ? (
            <div style={{ textAlign: "center", padding: "48px 0", color: "#9e9e9e" }}>Loading…</div>
          ) : filtered.length === 0 ? (
            <div style={{ textAlign: "center", padding: "48px 0", color: "#9e9e9e", fontSize: "0.9rem" }}>
              No files found
            </div>
          ) : (
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: "14px" }}>
              {filtered.map((doc) => (
                <DocumentCard
                  key={doc.id}
                  document={doc}
                  CardButtons={() => (
                    <button
                      onClick={(e) => { e.stopPropagation(); handleLink(doc); }}
                      disabled={linked[doc.id]}
                      style={{
                        display: "inline-flex", alignItems: "center", gap: "6px",
                        padding: "6px 14px", border: "none", borderRadius: "7px",
                        fontWeight: 600, fontSize: "0.82rem", cursor: linked[doc.id] ? "default" : "pointer",
                        background: linked[doc.id] ? "#e6f4ea" : "#f3e5f5",
                        color: linked[doc.id] ? "#1e7e34" : "#7b1fa2",
                        transition: "all 0.15s",
                      }}
                    >
                      <FontAwesomeIcon icon={linked[doc.id] ? faCheck : faPlus} />
                      {linked[doc.id] ? "Added" : "Add"}
                    </button>
                  )}
                />
              ))}
            </div>
          )}
        </Modal.Body>

        <Modal.Footer style={{
          background: "#fff", borderTop: "1px solid #f0f0f0",
          padding: "12px 24px", display: "flex", justifyContent: "flex-end",
        }}>
          <button onClick={() => setShow(false)} style={{
            padding: "8px 20px", background: "#f5f5f5", color: "#424242",
            border: "none", borderRadius: "8px", fontWeight: 600,
            fontSize: "0.88rem", cursor: "pointer",
          }}>
            Done
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DocumentLinker;
